import { CircleCheck } from "lucide-react";

const DeleteBranchSuccess = ({ closeDeleteBranchSuccess }) => {
  return (
    <div
      onClick={(e) => {
        closeDeleteBranchSuccess();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <CircleCheck color="#00A676" />
        <p className="text-[#5C5C5C] text-[16px] font-semibold">
          Success! Branch Deleted
        </p>
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          This branch has been successfully deleted and the microfinance
          branches database updated successfully.
        </p>
        <button
          onClick={closeDeleteBranchSuccess}
          className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default DeleteBranchSuccess;
